<template>
  <div class="order-page">
    <!-- <el-card class="box-card">
    </el-card>
    <el-card class="button-box">
      <el-row></el-row>
    </el-card>-->
    <el-card class="box-card">
      <!-- el-form -->

      <el-form :model="form"
               label-width="90px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item prop="platform_from"
                            label="平台">
                <el-select clearable
                           v-model="form.platform_from"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in tradefrom"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="4">
              <el-form-item prop="create_user"
                            label="操作人">
                <el-input v-model="form.create_user"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="action_type"
                            label="操作类型">
                <el-select clearable
                           v-model="form.action_type"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in [{'name':'upload'},{'name':'download'}]"
                             :key="item.name"
                             :label="item.name"
                             :value="item.name">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="report_type"
                            label="报表类型">
                <el-select clearable
                           v-model="form.report_type"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in reportTypeList"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width
                            prop="create_time"
                            label="日期">
                <!-- <el-input v-model="form.create_date"></el-input> -->
                <el-date-picker v-model="form.create_time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']"
                                style="width: 90%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine">
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table height="calc(100vh - 100px)"
              :data="tableData"
              border
              v-loading="loading"
              style="width:100%">
      <el-table-column prop="report_type"
                       align="center"
                       header-align="center"
                       label="报表类型"
                       min-width="160px"></el-table-column>
      <el-table-column prop="file_name"
                       align="center"
                       header-align="center"
                       label="文件名"
                       min-width="260px">
        <!-- <template slot-scope="scope">
          <el-row>
            <el-col>{{scope.row.file_name}}</el-col>
            <el-col>{{scope.row.input_file_name}}</el-col>
          </el-row>
        </template>-->
      </el-table-column>

      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       min-width="150px"
                       label="操作时间"></el-table-column>
      <el-table-column prop="create_user"
                       align="center"
                       header-align="center"
                       label="操作人"></el-table-column>
      <el-table-column prop="action_type"
                       align="center"
                       header-align="center"
                       label="操作类型"></el-table-column>
      <el-table-column prop="action_result"
                       align="center"
                       header-align="center"
                       label="操作结果"
                       min-width="125px">
        <template slot-scope="scope">
          <span v-if="scope.row.process_status === 1"
                style="color:#67C23A">{{ scope.row.action_result }}</span>

          <span style="color:#F56C6C"
                v-else-if="scope.row.process_status === 4"
                type="danger">{{ scope.row.action_result }}</span>
          <span style="color:#F56C6C"
                v-else-if="scope.row.process_status === 3"
                type="danger">{{ scope.row.action_result }}</span>

          <span style="color:#409EFF"
                v-else>{{ scope.row.action_result }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       align="center"
                       header-align="center"
                       label="备注"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.action_type === 'download' && scope.row.process_status === 1"
                     type="text"
                     @click="download(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
const tempPrefixeUrl = "https://datacenterapi.transecs.com/"
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
      reportTypeList: [],
    }
  },
  created() {
    // this.getTableData();
    this.getOperatelogReporttype()
  },
  methods: {
    download(row) {
      let url = tempPrefixeUrl + row.file_path
      console.log('url', url)
      window.open(url, '_blank')
      console.log(`文件地址：${row.file_path}`)

      // alert(`文件地址：${file_path}`);
    },

    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.list_api, this.queryPrdlists)
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
    async getOperatelogReporttype() {
      // this.loading = true
      let { data, err } = await this.axiosApi(Desc.type_api)
      // console.log("data", data);
      // this.tableData = data.data.data.data
      // this.total = parseInt(data.data.data.total)
      this.reportTypeList = data.data.data
      console.log(data.data.data)
      // console.log(data)
      // dealReturn(data, err)
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/operatelog/index.vue